// extracted by mini-css-extract-plugin
export default {"label":"Checkbox_label__O-SB1","reverse":"Checkbox_reverse__MlADw","input":"Checkbox_input__KAVVD"};